import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
  apiKey: "AIzaSyBVOdqbZH5seBAMMA5qWKTXAYOB0iWZDUk",
  authDomain: "retionz-cabs-system.firebaseapp.com",
  projectId: "retionz-cabs-system",
  storageBucket: "retionz-cabs-system.firebasestorage.app",
  messagingSenderId: "491416887238",
  appId: "1:491416887238:web:47237745e156265d345cc7"
};


const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };